import { render } from "./MdDialog.vue?vue&type=template&id=65069a88"
import script from "./MdDialog.vue?vue&type=script&lang=js"
export * from "./MdDialog.vue?vue&type=script&lang=js"

import "./MdDialog.vue?vue&type=style&index=0&id=65069a88&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__